<template>
  <div class="custom-label">
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择"
      :data="businessList"
      :clickAddButton="clickAddButton"
      @selectChange="selectChange"
    ></top-bar>
    <base-table
      :tableData="tableData"
      v-if="tableData.tableList"
      @handleClick="handleClick"
    ></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <!-- 新增 -->
    <base-dialog
      :dialogShow="dialogShow"
      @dialogHandel="dialogHandel"
      :formData="formData"
      @changeSelectVal="changeSelectVal"
      @closeDialog="closeDialog"
    ></base-dialog>
    <!-- 编辑 -->
    <base-dialog
      :dialogShow="editDialogShow"
      @dialogHandel="editDialogHandel"
      :formData="formData"
      @changeSelectVal="editChangeSelectVal"
      @closeDialog="editCloseDialog"
    ></base-dialog>
    <!-- 删除 -->
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
      @update:isShow="handleDialogLabel(false)"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="sortDialogFlag"
      title="新增排序"
      :isShowBtn="isShowBtn"
      :btnText="sortBtnText"
      @clickHandler="sortClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="排序" prop="nameValue">
            <el-input
              v-model.number="sortFormList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入大于零的整数"
            ></el-input>
          </el-form-item>
        </el-form></div
    ></modal>
  </div>
</template>

<script>
import topBar from "../../../../../components/topBar";
import baseTable from "../../../../../components/baseTable";
import breadCrumb from "../../../../../components/breadCrumb";
import baseDialog from "../../../components/baseDialog";
import pagination from "../../../../../components/pagination";
import {
  pageChannelsByCategoryId,
  saveOrUpdateContentChannel,
  deleteContentChannel,
  setSortContentChannelById,
} from "@/api/man";
import modal from "@/components/modal";
import { getContentTenantByUrlFlag } from "../../../../../api/user";
export default {
  name: "categoryManage",
  components: {
    baseTable,
    topBar,
    breadCrumb,
    baseDialog,
    pagination,
    modal,
  },
  data() {
    return {
      isShowSelect: false,
      businessList: [],
      dialogShow: false,
      formData: {
        formList: {
          title: "新增频道",
          nameKey: "频道名称",
          nameValue: "",
          belongInfo: "所属业务",
          infoKey: "备注",
          infoValue: "",
          placeholder: "请输入申请理由",
          maxlength: "150",
          type: 0, //0(13\16) or 1(28)
        },
      },
      sortFormList: {
        nameValue: "",
        nameType: "",
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "频道ID",
            prop: "id",
          },
          {
            label: "频道名称",
            prop: "name",
          },
          {
            label: "序号",
            prop: "sort",
          },
          {
            label: "所属栏目",
            prop: "contentCategoryName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
        ],
        tableType: 9,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      business_ID: 1, // 业务id
      editDialogShow: false,
      deleteDialog: false,
      sortDialogFlag: false,
      btnText: ["取消", "确认"],
      sortBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      editValue: "", // 需要修改的信息
      deleteValue: "", // 需要删除的信息
      sortValue: "", // 需要排序的信息
    };
  },
  watch: {
    "formData.formList.nameValue"(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.formList.nameValue = this.$utils.removalSpace(newValue);
      }
    },
  },
  created() {},
  mounted() {
    this.pageChannelsByCategoryId(); // 获取栏目对应的频道列表
  },
  methods: {
    selectChange(target) {
      this.business_ID = target;
      this.pageChannelsByCategoryId();
    },
    clickAddButton() {
      this.formData.formList.nameValue = "";
      this.formData.formList.infoValue = "";
      this.formData.formList.belongValue = "";
      this.dialogShow = true;
    },
    //新增
    dialogHandel(data) {
      this.dialogShow = data;
    },
    //修改
    editDialogHandel(data) {
      this.editDialogShow = data;
    },
    changeSelectVal(target) {
      this.business_ID = target;
    },
    editChangeSelectVal(target) {},
    closeDialog(type) {
      if (type === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != ""
        ) {
          saveOrUpdateContentChannel({
            tenantId: this.$commonJs.getTenantId(),
            contentCategoryId: this.$route.query.id,
            name: this.formData.formList.nameValue,
            remark: this.formData.formList.infoValue,
          })
            .then((res) => {
              if (res === 1) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogShow = false;
                this.pageChannelsByCategoryId();
              }
            })
            .catch((res) => {
              if (res.data === 0) {
                this.$message.error("添加失败");
              } else if (res.data === -1) {
                this.$message.error("名称已存在");
              }
            });
        } else {
          this.$message.error("请输入频道名称");
        }
      } else if (type === "cancel") {
        this.dialogShow = false;
      }
    },
    editCloseDialog(type) {
      if (type === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != ""
        ) {
          saveOrUpdateContentChannel({
            tenantId: this.$commonJs.getTenantId(),
            id: this.editValue.id,
            contentCategoryId: this.$route.query.id,
            name: this.formData.formList.nameValue,
            remark: this.formData.formList.infoValue,
          })
            .then((res) => {
              if (res?.success) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.editDialogShow = false;
                this.pageChannelsByCategoryId();
              }
            })
            .catch((res) => {
              this.$message.error(res.msg);
            });
        } else {
          this.$message.error("请输入频道名称");
        }
      } else if (type === "cancel") {
        this.editDialogShow = false;
      }
    },
    handleDialogLabel(val) {
      this.deleteDialog = val;
    },
    handleClick(val) {
      if (val.type === "edit") {
        this.editDialogShow = true;
        this.formData.formList.title = "修改业务";
        this.getEditVal(val.val);
        // 数据回显
        this.formData.formList.nameValue = val.val.name;
        this.formData.formList.type = 0;
        this.formData.formList.infoValue = val.val.remark;
      } else if (val.type === "sort") {
        this.sortFormList.nameValue = "";
        this.sortDialogFlag = true;
        this.getSorteVal(val.val);
      } else if (val.type === "delete") {
        this.getDeleteVal(val.val);
        this.deleteDialog = true;
      }
    },
    sortClickHandler(type) {
      if (type === "one") {
        this.sortDialogFlag = false;
      } else if (type === "two") {
        if (this.sortFormList.nameValue > 0) {
          setSortContentChannelById({
            tenantId: this.$commonJs.getTenantId(),
            id: this.sortValue.id,
            sort: this.sortFormList.nameValue,
          }).then((res) => {
            if (res) {
              this.$message({
                message: "排序成功",
                type: "success",
              });
              this.sortDialogFlag = false;
              this.pageChannelsByCategoryId();
            }
          });
        } else {
          this.$message.error("请输入大于0的整数");
        }
      }
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false);
    },
    // 删除
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteDialog = false;
      } else if (val === "two") {
        //确认删除
        this.deleteDialog = false;
        deleteContentChannel({
          tenantId: this.$commonJs.getTenantId(),
          id: this.deleteValue.id,
        })
          .then((res) => {
            if (res) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.pageChannelsByCategoryId();
            }
          })
          .catch((res) => {
            // if(res.code == 2203){
            this.$message.error(res.msg);
            // }
          });
      }
    },
    showDialog() {
      this.dialogShow = true;
    },
    pageChannelsByCategoryId() {
      pageChannelsByCategoryId({
        tenantId: this.$commonJs.getTenantId(),
        contentCategoryId: this.$route.query.id,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          this.tableData.tableList.push(item);
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
        });
      });
    },
    getEditVal(val) {
      this.editValue = val;
    },
    getDeleteVal(val) {
      this.deleteValue = val;
    },
    getSorteVal(val) {
      this.sortValue = val;
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageChannelsByCategoryId();
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.el-textarea__inner) {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
  display: inline-block;
  margin-bottom: 45px;
  margin-right: 15px;
  /*padding: 0 0;*/
  /*min-height: 23px;*/
}
:deep(.el-dialog__body) {
  padding: 30px 26px 0px 26px !important;
}
</style>
